import ListingApplicantDetailsTileContainer from './listing_applicant_details_tile_container';

const ListingApplicantDetailsTile = ListingApplicantDetailsTileContainer;
export default ListingApplicantDetailsTile;
